module.exports = __webpack_public_path__ + "img/r5.64e153a6.png";